import React, { useEffect } from 'react';

import Filters from '../Filters';
import Loader from '../../../Shared/Loader';
import TeamPlayersTable from './TeamPlayersTable';
import { saveDataPlayersOnLocalStorage } from '../../../../helpers/helpers';
import { FILTER_GLOBAL_KEYS, FILTER_KEYS } from '../../../../config/constants';
import { useRouter } from '../../../../helpers/customHooks';
import {
  useDataPlayersDispatch,
  useDataPlayersState,
  useDataTeamsState,
  useFiltersState
} from '../../../../store/hooks';

const PlayerPracticesTab = () => {
  const { specificScope } = useRouter();
  const { dataPlayers } = useDataPlayersState();
  const { dataTeam: team } = useDataTeamsState();
  const {
    [FILTER_GLOBAL_KEYS.WEEKS]: weeks,
    [FILTER_KEYS.DATE_RANGE]: filterDateRangeData,
    [FILTER_KEYS.POSITIONS]: filterPositionsData
  } = useFiltersState(specificScope, FILTER_GLOBAL_KEYS.WEEKS, FILTER_KEYS.DATE_RANGE, FILTER_KEYS.POSITIONS);
  const { getDataPlayersByTeamId } = useDataPlayersDispatch();
  useEffect(() => {
    if (team && team.teamId && weeks && filterDateRangeData && filterDateRangeData.selectedDates && filterDateRangeData.selectedDates.length && filterPositionsData) {
      getDataPlayersByTeamId(team.teamId, 'Practice')();
    }
  }, [weeks, filterDateRangeData]);
  useEffect(() => {
    saveDataPlayersOnLocalStorage();
  }, [dataPlayers]);
  
  const headers = [
    { content: 'PLAYER', style: { width: '300px' }, class: 'oo-i', isOrderly: true, leftSortIcon: '71px' },
    { content: 'NO.', style: { width: '51px' }, isOrderly: true },
    { content: 'POS.', style: { width: '51px' }, isOrderly: true },
    { content: 'AVG. MAX SPEED', style: { width: '90px' }, class: 'll-pp', isOrderly: true },
    { content: 'AVG. MAX SUST. SPEED', style: { width: '101px' }, class: 'll-pp', isOrderly: true },
    { content: 'AVG. TTL. DIST.', style: { width: '76px' }, class: 'll-pp', isOrderly: true },
    // { content: 'AVG. HARD EFF. DIST.', style: { width: '82px' }, class: 'll-pp', isOrderly: true },
    { content: 'AVG. ACCEL CT.', style: { width: '50px' }, class: 'll-pp', isOrderly: true },
    { content: 'AVG. DECEL CT.', style: { width: '50px' }, class: 'll-pp', isOrderly: true },
    { content: '', style: { width: '507px' } }
  ];
  
  return (
    <>
      <Filters />
      <div className="performance-body" style={{ height: 'calc(100vh - 175px)' }}>
        <Loader forceLoader={!weeks}>
          <TeamPlayersTable headers={headers} dataPlayers={dataPlayers} />
        </Loader>
      </div>
    </>
  );
};

export default PlayerPracticesTab;